"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const systemConfig_1 = require("@configs/systemConfig");
const NotFoundPage_1 = __importDefault(require("@containers/common/NotFoundPage"));
const DF0001_1 = __importDefault(require("@containers/DF0001"));
const HomePage_1 = __importDefault(require("@containers/HomePage"));
const PageLayout_1 = __importDefault(require("@layouts/PageLayout"));
const routerConfigs_1 = require("./routerConfigs");
const children = [
    { index: true, element: (0, jsx_runtime_1.jsx)(HomePage_1.default, {}) },
    { path: (_a = routerConfigs_1.routerURL.property) === null || _a === void 0 ? void 0 : _a[systemConfig_1.SystemFunctionSettings.DF0001], element: (0, jsx_runtime_1.jsx)(DF0001_1.default, {}) },
    { path: '*', element: (0, jsx_runtime_1.jsx)(NotFoundPage_1.default, {}) }
];
const routes = () => {
    return [
        {
            path: '/',
            element: (0, jsx_runtime_1.jsx)(PageLayout_1.default, {}),
            children
        },
        { path: '/login', element: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "Login" }) }
    ];
};
exports.default = routes;
